import axios from 'axios'
import Cookies from 'js-cookie'
import router from '@/router'
import qs from 'qs'
import { clearLoginInfo } from '@/utils'
import isPlainObject from 'lodash/isPlainObject'
import store from '@/store'
import { Message } from 'element-ui'

const http = axios.create({
  baseURL: window.SITE_CONFIG['api2URL'],
  timeout: 1000 * 180,
  withCredentials: true
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  config.headers['Accept-Language'] = Cookies.get('language') || 'zh-CN'
  config.headers['token'] = Cookies.get('token') || ''
  // 默认参数
  var defaults = {}
  // 防止缓存，GET请求默认带_t参数
  if (config.method === 'get') {
    config.params = {
      ...config.params,
      ...{ '_t': new Date().getTime() }
    }
  }
  let tenantId = ''
  if (store.state.user) {
    tenantId = store.state.user.tenantId
  }

  if (isPlainObject(config.params)) {
    config.params = {
      ...defaults,
      ...config.params,
      tenantId: tenantId
    }
  }
  if (isPlainObject(config.data)) {
    config.data = {
      ...defaults,
      ...config.data,
      tenantId: tenantId
    }
    if (/^application\/x-www-form-urlencoded/.test(config.headers['content-type'])) {
      config.data = qs.stringify(config.data)
    }
  }
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  if (response.data.code === 401 || response.data.code === 10001) {
    clearLoginInfo()
    if (router.currentRoute.path !== '/login') {
      router.replace({ name: 'login' }).catch(e => {
        console.log('登录超时', e)
      })
    }
    return Promise.reject(response.data)
  }
  if (response.config.responseType === 'blob') {
    return response.data
  } else if (response.data.code !== 0) {
    Message({
      type: 'error',
      message: response.data.msg
    })
    return Promise.reject(response.data)
  }
  return response.data.data
}, error => {
  console.error(error)
  return Promise.reject(error)
})

export default http
